export class UpgradePopupError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = 'UpgradePopupError';
  }
}
